import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

type InfiniteScrollContainerProps = ComponentPropsWithoutRef<'div'>;

export const InfiniteScrollContainer = forwardRef<HTMLDivElement, InfiniteScrollContainerProps>(
  ({ className, ...props }: InfiniteScrollContainerProps, ref) => {
    return <div ref={ref} className={cn('flex h-100 w-full items-center justify-center', className)} {...props} />;
  },
);
InfiniteScrollContainer.displayName = 'InfiniteScrollContainer';
